import React from 'react';
import { Container } from 'react-bootstrap';

function CanadaSection() {
  return (
    <Container>
      <div className='card mt-4'>
        <div className='card-body'>
          <h2>Canada</h2>
          <p>
            Is a country in North America. Its ten provinces and
            three territories extend from the Atlantic Ocean to the
            Pacific Ocean and northward into the Arctic Ocean, making
            it the world's second-largest country by total area, with
            the world's longest coastline.
          </p>
          <p>
            The country is characterized by a wide range of both
            meteorological and geological regions. The current population
            is estimated to be 40 million people. Canada's capital is Ottawa 
            and its three largest metropolitan areas are Toronto, Montreal, 
            and Vancouver.
          </p>
          <p>
            Canada is a parliamentary democracy and a constitutional monarchy 
            in the Westminster tradition. The country's head of government is 
            the prime minister, who holds office by virtue of their ability to 
            command the confidence of the elected House of Commons and is 
            "called upon" by the governor general, representing the monarch 
            of Canada, the head of state. The name of the current prime minister
            of Canada is Justin Trudeau.
          </p>
        </div>
        <div className='ratio ratio-16x9'>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/zm6gHJ3SQIM?si=IBUfvv7iiialwUlH" title="YouTube video player"
            frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen>
          </iframe>
        </div>
      </div>
      <br></br>
    </Container>
  );
}

export default CanadaSection;
